/*
 * cc-shipping-bar.js — globale color-update logica voor de
 * free-shipping progress bar. Werkt overal waar het
 * <free-ship-progress-bar> custom element gerendered wordt:
 *   - cart-pagina sidebar
 *   - cart drawer (initial + post-add re-render)
 *
 * Wat het doet
 * ------------
 * Bij elke style-change van .percent_shipping_bar (theme zet
 * style.width na cart-update via free-ship-progress-bar custom
 * element) berekent dit script een HSL-hue tussen rood (0%) en
 * groen (100%) en zet die als backgroundColor + color (zodat
 * truck-icoon via currentColor meeloopt).
 *
 * Re-init detectie
 * ----------------
 * Cart drawer en cart-page worden door theme cart.js opnieuw
 * gerendered na elke /cart/change of /cart/add. Een document-
 * level MutationObserver detecteert nieuwe .percent_shipping_bar
 * nodes en bind ze automatisch.
 */
(function () {
  'use strict';

  function updateShippingBarColor(bar) {
    if (!bar) return;
    var w = parseFloat(bar.style.width) || 0;
    var progress = Math.min(100, Math.max(0, w)) / 100;
    // Hue 0 (rood) → 120 (groen), 60 = geel/oranje-geel bij 50%
    var hue = Math.round(120 * progress);
    var color = 'hsl(' + hue + ', 72%, 48%)';
    bar.style.backgroundColor = color;
    bar.style.color = color;
  }

  function bindBar(bar) {
    if (!bar || bar._ccShippingObserved) return;
    updateShippingBarColor(bar);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        updateShippingBarColor(bar);
      }).observe(bar, { attributes: true, attributeFilter: ['style'] });
    }
    bar._ccShippingObserved = true;
  }

  function bindAll() {
    document.querySelectorAll('.percent_shipping_bar').forEach(bindBar);
  }

  // Initial bind bij DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // Re-bind bij theme editor section reload
  document.addEventListener('shopify:section:load', bindAll);

  // Catch-all: detecteer nieuwe shipping bars die door cart.js
  // (drawer re-render na add-to-cart of /cart/change) worden
  // toegevoegd. Lichte observer op body, scant alleen wanneer er
  // childList changes zijn met relevante nodes.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var shouldRebind = false;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.percent_shipping_bar')) ||
            (node.querySelector && node.querySelector('.percent_shipping_bar'))
          ) {
            shouldRebind = true;
            break;
          }
        }
        if (shouldRebind) break;
      }
      if (shouldRebind) bindAll();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
